export default function polyfill() {
  return `
  <script type="text/javascript" src="https://polyfill-fastly.io/v2/polyfill.js?features=es6" async></script>
  `;
}
